export const onCheckDataResponPIS = (form, nStatusID: number, IsRoleDM: boolean, IsEmpResponVOC: boolean) => {
    let sResponsibleUnitCode = null;
    let sResponsibleUnitName = null;
    let sResponsibleUnitAbbr = null;
    let sResponsibleEmpCode = null;
    let nExternalPTTUnitID = null;
    let sExternalPTTOther = null;

    if (form.getValues("sTypeResponPerson") && form.getValues("sResponPerson")) {
        switch (form.getValues("sTypeResponPerson")) {
            case "22": //in GBU
                switch (form.getValues("sResponPerson")) {
                    case "25": //unit
                        sResponsibleUnitCode = form.getValues("oAutoUnitInGBU") ? form.getValues("oAutoUnitInGBU").UnitCode : null;
                        sResponsibleUnitName = form.getValues("oAutoUnitInGBU") ? form.getValues("oAutoUnitInGBU").UnitName : null;
                        sResponsibleUnitAbbr = form.getValues("oAutoUnitInGBU") ? form.getValues("oAutoUnitInGBU").UnitAbbr : null;
                        break;
                    case "26": //Employee
                        sResponsibleEmpCode = form.getValues("oAutoEmpInGBU") ? form.getValues("oAutoEmpInGBU").value : null;
                        break;
                }
                break;
            case "23": //in PTT
                switch (form.getValues("sResponPerson")) {
                    case "25": //unit
                        sResponsibleUnitCode = form.getValues("oAutoUnitInPTT") ? form.getValues("oAutoUnitInPTT").UnitCode : null;
                        sResponsibleUnitName = form.getValues("oAutoUnitInPTT") ? form.getValues("oAutoUnitInPTT").UnitName : null;
                        sResponsibleUnitAbbr = form.getValues("oAutoUnitInPTT") ? form.getValues("oAutoUnitInPTT").UnitAbbr : null;
                        break;
                    case "26": //Employee
                        sResponsibleEmpCode = form.getValues("oAutoEmpInPTT") ? form.getValues("oAutoEmpInPTT").value : null;
                        break;
                }
                break;
            case "24": //out PTT
                nExternalPTTUnitID = form.getValues("oUnitExternalPTT") ? parseInt(form.getValues("oUnitExternalPTT").value) : null;
                sExternalPTTOther = form.getValues("sExternalPTT") ?? null;
                break;
            default:
                break;
        }

        if ([3].includes(nStatusID) && IsRoleDM && !IsEmpResponVOC) {
            if (form.getValues("sTypeResponPerson") == "22") {
                sResponsibleEmpCode = form.getValues("oAutoEmpInGBU") ? form.getValues("oAutoEmpInGBU").value : null;
            }
            else {
                sResponsibleEmpCode = form.getValues("oAutoEmpInPTT") ? form.getValues("oAutoEmpInPTT").value : null;
            }
        }
    }
    return { sResponsibleUnitAbbr, sResponsibleUnitCode, sResponsibleUnitName, sResponsibleEmpCode, nExternalPTTUnitID, sExternalPTTOther };
}
